import getOptionsFromPrefix from '../helpers/getOptionsFromPrefix';
import promiseTimeout from '../helpers/promiseTimeout';

const Download = {
  startDownload(btn, options) {
    this.btn = btn;
    this.options = options;

    this.toggleButton('waiting');

    const url = options.url.replace('{date}', options.date);

    window.axios.get(url)
      .then((res) => {
        this.toggleButton('success');

        window.open(`/admin/pdf/${res.data}`);

        return promiseTimeout(3000);
      })
      .then(() => {
        this.toggleButton('default');
      })
      .catch(() => {
        this.toggleButton('error');
      });
  },

  toggleButton(state) {
    this.btn.textContent = this.options[state];
    this.btn.disabled = (state !== 'default');
  },
};

const DownloadModal = {
  /**
   * Instantiate prompt
   * @param {HTMLElement} node
   * @param {Object} props
   * @return {void}
   */
  create(node, props) {
    this.node = node;

    let downloadButtons = node.querySelectorAll('.js-download-button');
    downloadButtons = Array.prototype.slice.call(downloadButtons);

    this.options = getOptionsFromPrefix(props, 'downloadModal');

    $(node).on('show.bs.modal', (e) => {
      this.date = e.relatedTarget.dataset.date;
    });

    downloadButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const download = { ...Download };
        const options = getOptionsFromPrefix(btn.dataset, 'downloadButton');

        options.date = this.date;

        download.startDownload(btn, options);
      });
    });
  },
};

export default DownloadModal;
